
import { InfiniteList } from '@src/design-system/molecules/infinite-list';
import {
    EditableDropdownCell,
    EditableDropdownCellEditMode,
    EditableDropdownCellItem,
    EditableDropdownCellViewMode,
} from '@src/shared/components/editable-dropdown-cell';
import universityStatusesApi from '../../services/university-statuses-api';
import universitiesApi from '../../services/universities-api';
import type { TStatus } from '../../types';

export function UniversityStatusCell({
    universityId,
    status,
    statusesTrigger,
}: {
    universityId: number;
    status?: TStatus;
    statusesTrigger?: React.ReactNode;
}) {
    const { mutate: updateUniversity } = universitiesApi.useUpdate();

    return (
        <EditableDropdownCell>
            <EditableDropdownCellViewMode className="capitalize">
                {statusesTrigger || status?.name || '-'}
            </EditableDropdownCellViewMode>

            <EditableDropdownCellEditMode>
                <InfiniteList
                    enableSearch
                    fetchInfiniteData={universityStatusesApi.useFetchInfinite}
                    props={{
                        listProps: { className: 'gap-0 p-0' },
                        listContainerProps: {
                            className: 'p-1 max-h-[200px]',
                        },
                        searchContainerProps: { className: 'p-1 mb-1' },
                        searchInputProps: {
                            placeholder: 'Search in Status',
                            size: 'xs',
                            className: 'text-sm placeholder:text-sm',
                        },
                    }}
                    renderItem={(r) => {
                        return (
                            <EditableDropdownCellItem
                                key={r.id}
                                isSelected={String(r.id) === String(status?.id)}
                                className="capitalize"
                                onClick={() =>
                                    updateUniversity({
                                        id: universityId,
                                        status: r.id,
                                    })
                                }
                            >
                                {r.name}
                            </EditableDropdownCellItem>
                        );
                    }}
                />
            </EditableDropdownCellEditMode>
        </EditableDropdownCell>
    );
}
